const indexItems = [
  {
    title: '热播国产剧',
    desc: '高分口碑国产剧集一网打尽',
    icon: 'ri-tv-line',
    color: 'primary',
  },
  {
    title: '院线大片',
    desc: '最新电影第一时间上线',
    icon: 'ri-film-line',
    color: 'accent',
  },
  {
    title: '热门综艺',
    desc: '爆笑综艺不间断更新',
    icon: 'ri-emotion-laugh-line',
    color: 'secondary',
  },
  {
    title: '动漫番剧',
    desc: '日漫国漫全收录',
    icon: 'ri-ghost-line',
    color: 'primary',
  },
  {
    title: '韩剧美剧',
    desc: '海外热剧同步追',
    icon: 'ri-global-line',
    color: 'accent',
  },
  {
    title: '纪录片',
    desc: '自然人文深度探索',
    icon: 'ri-earth-line',
    color: 'secondary',
  },
  {
    title: '短剧专区',
    desc: '高能短剧刷到停不下来',
    icon: 'ri-flashlight-line',
    color: 'primary',
  },
];

const colorMap: Record<string, { bg: string; iconBg: string; text: string }> = {
  primary: { bg: 'bg-primary-50', iconBg: 'bg-primary-100', text: 'text-primary-700' },
  accent: { bg: 'bg-accent-50', iconBg: 'bg-accent-100', text: 'text-accent-700' },
  secondary: { bg: 'bg-secondary-50', iconBg: 'bg-secondary-100', text: 'text-secondary-700' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              热门专题
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              精选七大影视分类，快速找到你想看的内容
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
            {indexItems.map((item) => {
              const c = colorMap[item.color];
              return (
                <a
                  key={item.title}
                  href="#cards"
                  className={`flex flex-col items-center text-center p-4 md:p-5 rounded-xl ${c.bg} hover:scale-[1.03] transition-transform cursor-pointer no-underline`}
                >
                  <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full ${c.iconBg} flex items-center justify-center mb-3`}>
                    <i className={`${item.icon} ${c.text} text-lg md:text-xl`}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}